import ENV from "app/utils/ENV";
import { Linking } from "react-native";

let navigationHelpers = {
  external(url) {
    if (ENV.WEB) {
      window.open(url, "_blank");
    } else {
      Linking.openURL(url).catch((err) =>
        console.warn("An error occurred", err)
      );
    }
  },
};

export default navigationHelpers;
